/**
 * Calculate input padding-left based on icon size for text-with-icon form components
 */
function calculateTextWithIconPadding() {
  // Handle all instances on the page
  const wrappers = document.querySelectorAll('[data-text-with-icon-wrapper]');

  wrappers.forEach(function(wrapper) {
    const iconWrapper = wrapper.querySelector('[data-icon-wrapper]');
    const input = wrapper.querySelector('[data-text-with-icon-input]');

    if (!iconWrapper || !input) return;

    // Get the actual rendered width of the icon container (includes icon + padding)
    const iconWidth = iconWrapper.offsetWidth;

    // Calculate padding: icon width + spacing (0.5rem = 8px)
    const spacing = 8; // 0.5rem spacing between icon and input text
    const paddingLeft = iconWidth + spacing;

    // Set the padding
    input.style.paddingLeft = paddingLeft + 'px';
  });
}

$(function() {
  calculateTextWithIconPadding();

  document.addEventListener('jb.section.rendered', () => {
    calculateTextWithIconPadding();
  });

  document.addEventListener('section.initiated', () => {
    calculateTextWithIconPadding();
  });

  document.addEventListener('reg_wall_opened', () => {
    calculateTextWithIconPadding();
  });

  // Recalculate on window resize (in case font-size changes or responsive breakpoints)
  let resizeTimeout;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(calculateTextWithIconPadding, 100);
  });

  // Recalculate when fonts are loaded (in case web fonts affect icon size)
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(calculateTextWithIconPadding);
  }
});
